import SubscriptionCard from './SubscriptionCard'
import EmptyState from '../../components/ui/EmptyState'

function SubscriptionList({ subscriptions, onEdit, onDelete, onAdd }) {
  if (subscriptions.length === 0) {
    return (
      <EmptyState
        icon="🔄"
        title="No subscriptions yet"
        description="Track your recurring expenses by adding subscriptions"
        action={onAdd}
        actionLabel="Add Subscription"
      />
    )
  }

  return (
    <div className="grid grid-3">
      {subscriptions.map(subscription => (
        <SubscriptionCard
          key={subscription.id}
          subscription={subscription}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  )
}

export default SubscriptionList
